export default function loadMarkerClusterer() {
    return new Promise((resolve, reject) => {
        if (window.MarkerClusterer) {
            resolve(window.MarkerClusterer);
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://unpkg.com/@google/markerclustererplus@4.0.1/dist/markerclustererplus.min.js';
        script.async = true;
        script.defer = true;

        script.addEventListener('load', () => {
            resolve(window.MarkerClusterer);
        });

        script.addEventListener('error', () => {
            reject(new Error('Failed to load MarkerClusterer'));
        });

        document.head.appendChild(script);
    });
}